import { Component, OnInit, ViewContainerRef, HostListener, EventEmitter, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import {ConstantMessages} from '../common/ConstantMessages';
import { ToastrService } from 'ngx-toastr';
//import { Cookie } from 'ng2-cookies/ng2-cookies';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { windowScreen } from 'src/app/services/utility.service';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';

@Component({
  selector: 'app-card-category',
  templateUrl: './card-category.component.html',
  styleUrls: ['./card-category.component.css']
})
export class CardCategoryComponent implements OnInit {

  public constants: Constants;
  public constantMessages: ConstantMessages;
  public pageSize: any = 0;
  public messageType: any;
  public screen: string = 'mobile';
  public VideoFilterModel = { videoId: 0, categoryId: 0, SubcategoryId: 0, StartRow: 0, PageSize: 800, ScreenType: 1, IsMainHomePageRequest: false };
  AllCardData: any = [];
  public CategoryData: any;
  public pageTitle: string = '';
  public isAllVideoLoading: boolean = false;
  public isShowLoader: boolean = false;
  public isShowNoContent: boolean = false;
  public isAllVideoLoaded: boolean = false;
  assetURL = environment.assetURL;
  public categoryName: string;
  public subCategoryName: string;
  //AllVideoData = this.homedata1.homepageData;
  subscription = new Subscription();
  constructor(private dialog: MatDialog, private _httpService: HTTPService,
    private _router: Router, private _route: ActivatedRoute, private messageService: MessageService,
    public toastr: ToastrService, vcr: ViewContainerRef, private sharedService: SharedService, private seoService: SeoService) {
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
    window.addEventListener('resize', this.handleWindowResize);
    // window.addEventListener('scroll', this.onScroll);
    this.GetCategoryDataList();
    // this.GetCategoryWiseVideoDataList();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    //this.login();
    var a = this.sharedService.userToEdit;
    window.scrollTo(0, 0);
    
    this.subscription.add(
      this._route.paramMap.subscribe(params => {
        this.categoryName = params.get("category");
        this.subCategoryName = params.get("subCategory");
        if (this.subCategoryName == null)
          this.subCategoryName = this.categoryName;
        const queryData = this.sharedService.decryptAndParseQueryString(params.get("data"));
        if (queryData != undefined) {
          this.VideoFilterModel.categoryId = queryData.categoryId;
          this.VideoFilterModel.SubcategoryId = queryData.subCategoryId;
          this.AllCardData = [];
          this.VideoFilterModel.StartRow = 0;
          this.GetCategoryWiseVideoDataList();
          this.isAllVideoLoading = false;
          this.isAllVideoLoaded = false;
        }
      }));
    this.handleWindowResize();
  }
  ngAfterViewInit(): void {
    let seoTags = this.sharedService.getSeoTags(false, this.VideoFilterModel.categoryId, this.VideoFilterModel.SubcategoryId, this.categoryName, this.subCategoryName);
    this.seoService.generateTags({
      title: seoTags.metaTitle,
      description: seoTags.metaDescription,
      image: `${this.assetURL}/assets/images/logo.png`,
      keywords: seoTags.metaKeywords
    });
  }

  handleWindowResize = (): void => {
    this.screen = windowScreen();
  }

  public GetCategoryDataList() {
    this.subscription.add(
      this._httpService.ajaxPost('homepage/GetCardCategoryData', { pCategoryId: "0" }).subscribe(
        data => {
          if (data["Message"].MessageTypeValue == this.messageType.Success) {

            this.CategoryData = data["CardCategoryData"];
            var categroydata = this.CategoryData.filter(x => x.CardCategoryId == this.VideoFilterModel.categoryId)[0];
            this.pageTitle = "";
            if (categroydata != null && categroydata != "") {
              this.pageTitle = "Customizable Invitations for " + categroydata.CardCategoryDesc;
            }
          }
          else if (data["Message"].MessageTypeValue == 6) {
            this.isAllVideoLoaded = true;
          }
          else {
            this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
          }
        },
        (error: any) => {
          // this.hideSpinner();
          // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
        }));
  }

  public GetCategoryWiseVideoDataList() {
    if (this.isAllVideoLoading) return false;
    this.isAllVideoLoading = true;
    this.isShowLoader = true;
    // this.AllVideoData = this.homedata1.homepageData;
    this.subscription.add(
      this._httpService.ajaxPost('homepage/GetHomepageData', this.VideoFilterModel).subscribe(
        data => {
          if (data["Message"].MessageTypeValue == this.messageType.Success || data["Message"].MessageTypeValue == 6) {
            var allCardData = data["AllCardData"];
            if (allCardData != null && allCardData.length > 0) {
              allCardData.forEach(element => {
                this.AllCardData.push(element);
              });
            }
            else {
              this.isShowNoContent = true;
            }
            this.isShowLoader = false;
            //removed scrolled event
            //window.addEventListener('scroll', this.onScroll, true); //third parameter

          }
          else if (data["Message"].MessageTypeValue == 6) {
            if (this.AllCardData.length == 0)
              this.isShowNoContent = true;
            this.isAllVideoLoaded = true;
            this.isShowLoader = false;
          }
          else {
            this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
            this.isShowLoader = false;
          }
          this.isAllVideoLoading = false;
        },
        (error: any) => {
          // this.hideSpinner();
          // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
        }));
  }

  bottomReached(): boolean {
    return Math.round(window.innerHeight + window.scrollY) >= document.body.offsetHeight;
  }

  // @HostListener("window:scroll", [])
  onScroll = (event): void => {
    const bottomReached = Math.round(window.innerHeight + window.scrollY) >= document.body.offsetHeight;
    if (bottomReached) {
      if (this.isAllVideoLoaded) return;
      this.VideoFilterModel.StartRow = this.AllCardData.length;
      this.GetCategoryWiseVideoDataList();
    }

  }

  openDialog(): void {
    this.dialog.open(LoginComponent)
  }

  public openVideoPage(item) {
    let encryptedqueryparams: { videoId: any; };
    encryptedqueryparams = {
      videoId: item.VideoId
    };
    this._router.navigate([`/videopage/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
    //this._router.navigate(['/personalize']);
  }
}
